export default __webpack_public_path__ + "static/media/media_background.a3fc5483.png";